import * as actionTypes from '../actions/actionTypes';
import {cloneDeep} from "lodash";

const initialState = {
    list: [],
    loading: false,
    totalCount: 0,
    hasNext: false
};

const loadNotifications = (state) => {
    return {
        ...state,
        loading: true
    }
}

const concatNotifications = (state, action) => {
    let notifications = state.list.concat(action.notifications)
    return {
        ...state,
        list: notifications,
        loading: false,
        hasNext: action.hasNext
    }
};

const resetNotifications = (state) => {
    return {
        ...state,
        list: [],
        hasNext: false
    }
}

const setFullShowNotification = (state, action) => {
    const x = state.list.map((item, index) => {
        const x = cloneDeep(item)
        if (index === action.index) {
            x.fullShow = !x.fullShow
        }
        return x;
    })
    return {
        ...state,
        list: x
    }
}

const updateNotifications = (state) => {
    return {
        ...state
    }
}

const loadNotViewedNotificationsCount = (state) => {
    return {
        ...state,
    }
}

const setNotViewedNotificationsCount = (state, action) => {
    return {
        ...state,
        totalCount: action.totalCount
    }
}

const reducer = (state = initialState, action) => {
    switch (action.type) {case actionTypes.LOAD_NOTIFICATIONS: return loadNotifications(state);
        case actionTypes.CONCAT_NOTIFICATIONS: return concatNotifications(state, action);
        case actionTypes.RESET_NOTIFICATIONS: return resetNotifications(state);
        case actionTypes.UPDATE_NOTIFICATIONS: return updateNotifications(state);
        case actionTypes.LOAD_NOT_VIEWED_NOTIFICATIONS_COUNT: return loadNotViewedNotificationsCount(state);
        case actionTypes.SET_NOT_VIEWED_NOTIFICATIONS_COUNT: return setNotViewedNotificationsCount(state, action);
        case actionTypes.SET_FULL_SHOW_FOR_NOTIFICATION: return setFullShowNotification(state, action);
        default: return state;
    }
};
export default reducer;